import { render, staticRenderFns } from "./BlockProjectTools.vue?vue&type=template&id=71ad36c5"
import script from "./BlockProjectTools.vue?vue&type=script&lang=js"
export * from "./BlockProjectTools.vue?vue&type=script&lang=js"
import style0 from "./BlockProjectTools.vue?vue&type=style&index=0&id=71ad36c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports